import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
/* eslint-disable max-classes-per-file */
import React, { Component } from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
class ReactPageletContainer extends Component {
  constructor() {
    super(...arguments);
    // eslint-disable-next-line react/destructuring-assignment
    _defineProperty(this, "state", this.props.initialProps);
  }
  render() {
    return /*#__PURE__*/React.createElement(this.props.Wrapped, this.state);
  }
}
_defineProperty(ReactPageletContainer, "defaultProps", {
  initialProps: {}
});
process.env.NODE_ENV !== "production" ? ReactPageletContainer.propTypes = {
  initialProps: PropTypes.shape()
} : void 0;
export default class ReactPagelet {
  constructor(component, componentProps) {
    _defineProperty(this, "reactRef", /*#__PURE__*/React.createRef());
    _defineProperty(this, "initialProps", {});
    _defineProperty(this, "updateReactProps", evt => {
      this.reactRef.current.setState(evt.detail.props);
    });
    this.component = component;
    this.componentProps = componentProps;
  }
  mount(container) {
    /*
    Would use hydrate to properly re-use server generated DOM.
    However, this causes a bug if the server generated markup is significantly different from the
    client generated markup. Therefore, using #render to ovewrite whatever HTML is there
    */

    ReactDOM.render( /*#__PURE__*/React.createElement(ReactPageletContainer, {
      ref: this.reactRef,
      Wrapped: this.component,
      initialProps: {
        ...container.props,
        ...this.componentProps
      }
    }), container.mountNode);
    container.pageletDidRender();
    container.addEventListener('props', this.updateReactProps);
  }
  unmount(container) {
    container.removeEventListener('props', this.updateReactProps);
    ReactDOM.unmountComponentAtNode(container.mountNode);
    container.pageletDidUnrender();
  }
}